import React from "react";

import { User, useSessionStorage } from "@themuse/design-system/lib/main";
import { AppDispatch, UserActionTypes } from "interfaces/context/appContextInterfaces";
import { useUserDispatch } from "hooks/UserContext";
import mockUser from "mocks/mockUser.json";
import { getCarmenData } from "./location";
import { fetchUser } from "./api";
import { formatLog } from "./logging";

const setUserCarmenData = async (setUserLocation: any) => {
    try {
        const carmenResponse = await getCarmenData();
        if (carmenResponse) {
            setUserLocation(JSON.stringify(carmenResponse));
        }
    } catch (error) {
        const msg = `${process.env.APP_NAME} was unable to load location from Carmen.`;
        console.error(msg);
        console.error(error);
    }
};

const setUser = async (userLocation: string, dispatch: AppDispatch) => {
    try {
        let apiUser: User;
        // User only works in production and staging.
        if (!["www.themuse.com", "www.staging-themuse.com"].includes(window.location.host)) {
            apiUser = mockUser;
        } else {
            apiUser = await fetchUser();
        }

        const userData = userLocation ? {
            location: JSON.parse(userLocation)
        } : {};

        const payload = {
            ...apiUser,
            ...userData,
            isInitialized: true,
        };

        dispatch({
            type: UserActionTypes.updateUser,
            payload
        });
    } catch (error) {
        const msg = "Company Renderer was unable to request the user.";
        console.error(msg, JSON.stringify(formatLog({ error })));
    }
};

const UserInit: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [userLocation, setUserLocation] = useSessionStorage("user_location");
    const appDispatch = useUserDispatch();

    React.useEffect(() => {
        setUser(userLocation, appDispatch).catch(console.error);
    }, [userLocation]);

    React.useEffect(() => {
        setUserCarmenData(setUserLocation).catch(console.error);
    }, []);

    return <>{ children }</>;
};

export {
    setUserCarmenData,
    setUser,
    UserInit
};
